import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/find-doctors', label: 'Find Doctors' },
    { path: '/book-appointment', label: 'Book Appointment' },
    { path: '/telemedicine', label: 'Telemedicine' },
    { path: '/patient-portal', label: 'Patient Portal' }
  ];

  const supportLinks = [
    { path: '/help', label: 'Help Center' },
    { path: '/contact', label: 'Contact Us' },
    { path: '/emergency', label: 'Emergency' },
    { path: '/faq', label: 'FAQ' }
  ];

  const legalLinks = [
    { path: '/privacy', label: 'Privacy Policy' },
    { path: '/terms', label: 'Terms of Service' },
    { path: '/hipaa', label: 'HIPAA Notice' },
    { path: '/cookies', label: 'Cookie Policy' }
  ];

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section company-info">
            <div className="footer-logo">
              <Heart className="logo-icon" />
              <span>DoctDash</span>
            </div>
            <p className="company-description">
              Connecting patients with the right healthcare providers across India. 
              Your health is our priority.
            </p>
            <div className="contact-info">
              <div className="contact-item">
                <Phone size={16} />
                <span>Emergency: 108 (Ambulance), 102 (Police)</span>
              </div>
              <div className="contact-item">
                <Mail size={16} />
                <span>support@doctdash.in</span>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>Available across India</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              {supportLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              {legalLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div className="footer-section newsletter">
            <h4>Stay Updated</h4>
            <p>Get the latest health tips and updates</p>
            <div className="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email"
                className="newsletter-input"
                aria-label="Email address for newsletter"
              />
              <button className="newsletter-btn" type="button">
                Subscribe
              </button>
            </div>
            <div className="social-links">
              {socialLinks.map((social) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    className="social-link"
                    aria-label={social.label}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <IconComponent size={20} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} DoctDash India. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms">Terms</Link>
              <Link to="/accessibility">Accessibility</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
